function useAdminTokenCheck(): string {
    const localStorageValue = localStorage.getItem('admin-token') as string;
    return localStorageValue;
}

export default useAdminTokenCheck;